export default "__VITE_ASSET__B5vcS2uL__"